var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Fill/inbox"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.342 5.55276C8.511 5.21376 8.858 4.99976 9.237 4.99976H14.764C15.143 4.99976 15.489 5.21376 15.658 5.55276L18.382 10.9998H16C15.448 10.9998 15 11.4478 15 11.9998V13.9998C15 14.5528 14.552 14.9998 14 14.9998H10C9.448 14.9998 9 14.5528 9 13.9998V11.9998C9 11.4478 8.552 10.9998 8 10.9998H5.618L8.342 5.55276ZM20.789 11.3418L17.447 4.65776C16.936 3.63576 15.908 2.99976 14.764 2.99976H9.236C8.092 2.99976 7.065 3.63576 6.553 4.65776L3.211 11.3418C3.073 11.6178 3 11.9278 3 12.2368V17.9998C3 19.6548 4.346 20.9998 6 20.9998H18C19.655 20.9998 21 19.6548 21 17.9998V12.2368C21 11.9278 20.927 11.6178 20.789 11.3418Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_21269",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 18,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.342 5.55276C8.511 5.21376 8.858 4.99976 9.237 4.99976H14.764C15.143 4.99976 15.489 5.21376 15.658 5.55276L18.382 10.9998H16C15.448 10.9998 15 11.4478 15 11.9998V13.9998C15 14.5528 14.552 14.9998 14 14.9998H10C9.448 14.9998 9 14.5528 9 13.9998V11.9998C9 11.4478 8.552 10.9998 8 10.9998H5.618L8.342 5.55276ZM20.789 11.3418L17.447 4.65776C16.936 3.63576 15.908 2.99976 14.764 2.99976H9.236C8.092 2.99976 7.065 3.63576 6.553 4.65776L3.211 11.3418C3.073 11.6178 3 11.9278 3 12.2368V17.9998C3 19.6548 4.346 20.9998 6 20.9998H18C19.655 20.9998 21 19.6548 21 17.9998V12.2368C21 11.9278 20.927 11.6178 20.789 11.3418Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_21269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.e060ac39a6dee6627a98a966a6f9ecd6.svg";
export { ForwardRef as ReactComponent };